export const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: '📊',
      path: '/dashboard'
    },
    {
      id: 'leaderboard',
      label: 'Leaderboard',
      icon: '🏆',
      path: '/leaderboard'
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: '📋',
      path: '/reports'
    },
    {
      id: 'inbox',
      label: 'Inbox',
      icon: '✉️',
      path: '/inbox'
    },
    {
      id: 'sales-pipeline',
      label: 'Sales Pipeline',
      icon: '📋',
      path: '/sales-pipeline'
    },
    {
      id: 'accounts',
      label: 'Accounts',
      icon: '🏢',
      path: '/accounts'
    },
    {
      id: 'contacts',
      label: 'Contacts',
      icon: '☎️',
      path: '/contacts'
    },
    // {
    //   id: 'quotes',
    //   label: 'Quotes',
    //   icon: '💼',
    //   path: '/quotes'
    // },
    {
      id: 'team',
      label: 'Team',
      icon: '👥',
      path: '/users'
    },
    {
      id: 'targets',
      label: 'Targets',
      icon: '🎯',
      path: '/targets',
    },
    {
      id: 'sales-performance',
      label: 'Sales Performance',
      icon: '📈',
      hasSubmenu: true,
      roleRestrictions: ['MD Office', 'Company Sales Head'],
      submenu: [
        {
          id: 'targets-set',
          label: 'Set Targets',
          icon: '🎯',
          path: '/targets/set',
        },
        {
          id: 'actuals-set',
          label: 'Report Actuals',
          icon: '🎯',
          path: '/actuals/set',
        },
      ]
    },
    {
      id: 'activity-log',
      label: 'Activity Log',
      icon: '🔍',
      path: '/activity-log',
      roleRestrictions: ['MD Office', 'Company Sales Head'],
    }

  ];

// Helper function to check if user has access to a menu item
export const hasAccess = (menuItem, userRole) => {
  // If no role restrictions are defined, the item is accessible to all
  if (!menuItem.roleRestrictions || menuItem.roleRestrictions.length === 0) {
    return true;
  }
  
  // Check if user's role is in the allowed roles list
  const hasPermission = menuItem.roleRestrictions.includes(userRole);
  return hasPermission;
};

// Function to filter menu items based on user role
export const getFilteredMenuItems = (userRole) => {
  const filtered = menuItems.filter(item => hasAccess(item, userRole));
  return filtered;
};